























































































































import { Component, Mixins, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon } from '../../../../../../../../../../BotProperties/utils'
import { BaseButton } from '../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/types'
import { SocketNames } from '../../../../../../../../components'
import ButtonView from '../../../../../../../../components/NodeButtonsView/ButtonView.vue'
import RowButtonView from '../../../../../../../../components/NodeButtonsView/RowButtonView.vue'
import { SampleNodeMixin } from '../../../../../../../../logic/Nodes'
import { NotifyGroupAction } from '../../../../../Action/logic/Actions/NotifyGroupAction/NotifyGroupAction'
import { NotifyUsersAction } from '../../../../../Action/logic/Actions/NotifyUsersAction/NotifyUsersAction'
import ProxyUserInputAction from '../../../../logic/Proxy/actions/ProxyUserInputAction'
import { SendMessageNode } from '../../../../logic/SendMessageNode'
import ActionDescriptions from './actionDescriptions/ActionDescriptions.vue'

@Component({
  data() {
    return {
      SocketNames,
      getNewPropertyIcon,
    }
  },
  components: {
    ButtonView,
    ActionDescriptions,
    RowButtonView,
  }
})
export default class UserInputActionSample extends Mixins(SampleNodeMixin) {
  @Prop() action!: ProxyUserInputAction

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() node!: SendMessageNode

  selectedButtons: Array<number> = []

  get property(): GroupedBotProperty | undefined {
    return  this.properties.find((p) => p.id === this.action.action.property_index)
  }

  get actionsButtons(): Array<Array<BaseButton>> {
    const buttons: Array<Array<BaseButton>> = []

    this.action.action.actions.forEach((a) => {
      if ((a instanceof NotifyUsersAction || a instanceof NotifyGroupAction) && a.variants[0]?.buttons.length) {
        buttons.push(...a.variants[0].buttons)
      }
    })

    return buttons
  }
}
